import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { formatEuro } from '../../../functions/formatNumber.js';
import { strDateToDDMMYYYY } from '../../../functions/formatDate.js';

const TransaccioCardMensual = ({ tx, assetName }) => {
  const getTxTypeColor = (type) => {
    if (type === 'COMPRA') return '#4CAF50';
    if (type === 'VENDA') return '#EF4444';
    return '#FF9800';
  };

  const txColor = getTxTypeColor(tx.tipusTransaccio);

  return (
    <Card elevation={1} sx={{ borderRadius: '12px', border: '1px solid #E0E0E0' }}>
      <CardContent sx={{ p: '12px !important' }}>
        {/* Fila 1: Data i Badge */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
          <Typography variant="caption" sx={{ fontWeight: 'bold', color: 'text.secondary' }}>
            {strDateToDDMMYYYY(tx.fecha)}
          </Typography>
          <Box
            sx={{
              backgroundColor: `${txColor}1A`,
              color: txColor,
              borderRadius: '6px',
              px: 1,
              py: 0.2,
              fontSize: '0.75rem',
              fontWeight: 'bold',
            }}
          >
            {tx.tipusTransaccio}
          </Box>
        </Box>

        {/* Fila 2: Actiu */}
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', my: 0.2 }}>
          {assetName}
        </Typography>

        {/* Fila 3: Detalls Quantitat / Preu i Total */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            {tx.quantitat} ut @ {formatEuro(tx.preuUnitariEur)}/ut
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            {formatEuro(tx.totalEur)}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TransaccioCardMensual;
